// utils/auth.js
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const ACCESS_KEYS = ['access_token', 'token'];
const REFRESH_KEYS = ['refresh_token', 'refresh'];

export const readAccessToken = () => {
  // 1) cookies
  for (const k of ACCESS_KEYS) {
    const v = getCookie(k);
    if (v) return v;
  }
  // 2) localStorage
  for (const k of ACCESS_KEYS) {
    const v = localStorage.getItem(k);
    if (v) return v;
  }
  return null;
};

export const readRefreshToken = () => {
  for (const k of REFRESH_KEYS) {
    const v = getCookie(k);
    if (v) return v;
  }
  for (const k of REFRESH_KEYS) {
    const v = localStorage.getItem(k);
    if (v) return v;
  }
  return null;
};

export const saveAccessToken = (token) => {
  try { localStorage.setItem('access_token', token); } catch {}
  try {
    // cookie no httpOnly para poder leerla desde front (si usas httpOnly, no podrás leerla)
    document.cookie = `access_token=${token}; path=/; SameSite=Lax`;
  } catch {}
};

const isTokenNotValidPayload = async (resp) => {
  try {
    const text = await resp.text();
    try {
      const j = JSON.parse(text);
      return (
        j?.code === 'token_not_valid' ||
        j?.detail?.includes?.('not valid') ||
        j?.messages?.some?.(m => m?.message?.toLowerCase?.().includes('not valid'))
      );
    } catch {
      return false;
    }
  } catch {
    return false;
  }
};

export const fetchWithAuth = async (url, options = {}) => {
  let access = readAccessToken();
  if (!access) {
    // si no hay access token, intentamos refresh directo
    const refreshed = await tryRefresh();
    if (!refreshed) throw new Error('Sin token de acceso y no se pudo refrescar');
    access = readAccessToken();
  }

  const headers = new Headers(options.headers || {});
  headers.set('Authorization', `Bearer ${access}`);

  let resp = await fetch(url, { ...options, headers });

  if (resp.status !== 401) return resp;

  // Si es 401, verificamos si es por token_not_valid
  const notValid = await isTokenNotValidPayload(resp);
  if (!notValid) return resp;

  // Intentamos refresh
  const refreshed = await tryRefresh();
  if (!refreshed) return resp; // seguirá 401

  const newAccess = readAccessToken();
  const headers2 = new Headers(options.headers || {});
  headers2.set('Authorization', `Bearer ${newAccess}`);

  return fetch(url, { ...options, headers: headers2 });
};

const tryRefresh = async () => {
  const refresh = readRefreshToken();
  if (!refresh) return false;

  // Ajusta esta URL a la que tengas configurada en tu backend
  const refreshUrl = `${process.env.REACT_APP_SERVER_URL}/api/auth/token/refresh/`;

  const r = await fetch(refreshUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh }),
  });

  if (!r.ok) return false;

  const data = await r.json();
  const newAccess =
    data.access || data.token || data.access_token;

  if (!newAccess) return false;

  saveAccessToken(newAccess);
  return true;
};
